export { default } from './QuantityTableFooter';
